import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Volumes } from './Volumes';
import { Bonuses } from './Bonuses';
import { CtaButton } from './CtaButton';
export function WhatsIncluded() {
  return <section id="volumes" className="bg-paper py-14 lg:py-24" data-id="element-209" data-mp="3uaf82lqwqmhn">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-210" data-mp="25tec7a360iu">
        <SectionHeading title="6 Practical Volumes for the Moments When Worry Shows Up" data-id="element-211" data-mp="26cvhlrwwkvt" />
        <Volumes data-id="element-212" data-mp="pwpbzl183py0" />
        <Bonuses data-id="element-213" data-mp="pw76rywl21dy" />
        <div className="mt-10 text-center" data-id="element-214" data-mp="ptl34actc610">
          <CtaButton className="w-full sm:w-auto" data-id="element-215" data-mp="utfsg9gxwnjy">Get the Complete Toolkit</CtaButton>
        </div>
      </div>
    </section>;
}